export default __webpack_public_path__ + "static/media/src_jquery_mobile_2.8f8c5ee1.jpg";